import { $PropertyType } from "utility-types"
import { IUser } from "../Auth"

interface IBreakdown {
	reference?: { id: number; name: string }
	day_offset: number
	instalment_breakup_in_percent: number
}
interface NewItemCredentials {
	breakdowns?: IBreakdown[]
}

export type TCustomerPaymentPreference = {
	id: number
	name: string
	created_at: string
	created_by: IUser
	deleted_at: string | null
	days_before_trip_start: DaysBeforeTripStart
	trips_count: number | null
	trip_duration: TripDuration
	package_price_range: PackagePriceRange[]
	breakdowns: instalmentBreakdown[]
	preference_condition: string
	flight_include: boolean
	min_first_instalment_amounts: Array<{
		id: number
		amount: {
			amount: number
			currency: string
			formatted: number
		}
	}>
}

type DaysBeforeTripStart = {
	condition: "is_less" | "is_greater"
	days: number
}

type TripDuration = {
	condition: "is_less" | "is_greater"
	nights: number
}

type PackagePriceRange = {
	id: number
	amount: { amount: number; currency: string; formatted: string }
	condition: number
}
export type instalmentBreakdown = {
	created_at: Date
	day_offset: number
	id: number
	instalment_breakup_in_percent: number
	preference_id: number
	reference: number
	updated_at: Date
}
export function getTotalAmountShare(
	breakdowns: $PropertyType<NewItemCredentials, "breakdowns">
) {
	return (breakdowns || []).reduce(
		(total, { instalment_breakup_in_percent }) =>
			Number(total) + Number(instalment_breakup_in_percent),
		0
	)
}
